module.exports = __webpack_public_path__ + "static/media/rightArrow.c0894f39.svg";